import React from "react";
import { pure } from "recompose";

import EventEmitter from "services/event-emitter";

const eventEmitter = EventEmitter.getInstance();

const onClickHandler = e => {
  e.preventDefault();
  eventEmitter.trigger("team-profile-modal-show");
};

const TeamProfileLink = pure(() => (
  <a href="/#" id="team-profile-link" onClick={onClickHandler}>
    Team Profile
  </a>
));

export default TeamProfileLink;



// WEBPACK FOOTER //
// ./src/components/navigation/topbar/team-profile-link.js